export const EXTERNAL_LINKS = {
  ENCUMBRANCE:
    'https://www.monash.edu/students/support/connect/encumbrances?chatbot=open&hiddenMessage=remove%20encumbrance',
};

export default EXTERNAL_LINKS;
